import type { PixelEvent } from '@/events';

import type { IEventQueue } from '../queue/types';
import { EnqueueStage } from './stages/EnqueueStage';
import { NormalizeStage } from './stages/NormalizeStage';
import { ValidateStage } from './stages/ValidateStage';
import type { PipelineResult, PipelineStage } from './types';

export class TransportPipeline {
  private readonly stages: readonly PipelineStage[];

  private lastSteps: string[] = [];

  constructor(stages: readonly PipelineStage[]) {
    this.stages = stages;
  }

  static createDefault(queue: IEventQueue): TransportPipeline {
    return new TransportPipeline([
      new ValidateStage(),
      new NormalizeStage(),
      new EnqueueStage(queue),
    ]);
  }

  process(event: PixelEvent): PipelineResult {
    const steps: string[] = [];
    let current: PixelEvent | null = event;

    for (const stage of this.stages) {
      steps.push(stage.name);
      if (!current) break;
      current = stage.process(current);
    }

    this.lastSteps = steps;
    return { event: current, steps };
  }

  getLastSteps(): readonly string[] {
    return this.lastSteps;
  }
}
